import {
  server,
  OK,
  YES,
  HTTP_GETPROJECTDETAIL_FETCHING,
  HTTP_GETPROJECTDETAIL_SUCCESS,
  HTTP_GETPROJECTDETAIL_FAILED,
  HTTP_UPDATEPROJECTDETAIL_FETCHING,
  HTTP_UPDATEPROJECTDETAIL_SUCCESS,
  HTTP_UPDATEPROJECTDETAIL_FAILED,
} from "././../../Constants";
import { httpClient } from "././../../utils/HttpClient";
import Axios from "axios";

export const setStateProjectDetailToFetching = () => ({
  type: HTTP_GETPROJECTDETAIL_FETCHING,
});

export const setStateProjectDetailToSuccess = (payload) => ({
  type: HTTP_GETPROJECTDETAIL_SUCCESS,
  payload,
});

export const setStateProjectDetailToFailed = (payload) => ({
  type: HTTP_GETPROJECTDETAIL_FAILED,
});

export const setStateUpProjectDetailToFetching = () => ({
  type: HTTP_UPDATEPROJECTDETAIL_FETCHING,
});

export const setStateUpProjectDetailToSuccess = (payload) => ({
  type: HTTP_UPDATEPROJECTDETAIL_SUCCESS,
  payload,
});

export const setStateUpProjectDetailToFailed = (payload) => ({
  type: HTTP_UPDATEPROJECTDETAIL_FAILED,
});

export const getProjectDetail = (pid) => {
  return async (dispatch) => {
    dispatch(setStateProjectDetailToFetching());
    try {
      const result = await httpClient.get(
        `${server.GETPROJECTDETAIL_URL}/${pid}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(setStateProjectDetailToSuccess(result.data));
    } catch (error) {
      dispatch(setStateProjectDetailToFailed());
    }
  };
};

export const updateProjectDetailById = (budgetsdsid, item) => {
  return async (dispatch) => {
    dispatch(setStateUpProjectDetailToFetching());
    try {
      return await Axios.put(
        `${server.UPDATEPROJECTDETAIL_URL}/${budgetsdsid}`,
        item,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      ).then(() => {
        dispatch(setStateUpProjectDetailToSuccess("success"));
      });
    } catch (error) {
      dispatch(setStateUpProjectDetailToFailed());
    }
  };
};
